import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SessionActions } from './session.actions';
import { CARGOCHIEF_KEYS, ACCOUNT_TYPE } from '@domain/constants/app-variables';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';

@Injectable({
	providedIn: 'root',
})
export class LegacySessionEffects {
	constructor(
		private actions$: Actions<any>,
		private segmentWrapper: SegmentWrapperService,
		private cargoChief: Cargochief
	) {}

	loginSetupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(SessionActions.login.setup.success),
				tap(({ payload }) => {
					const user = { ...payload.user };
					localStorage.setItem('loggedInUser', JSON.stringify(user));
					this.segmentWrapper.fireSegmentIdentify(String(user.id), user);
					this.cargoChief.setItem({ [CARGOCHIEF_KEYS.LOGGED_IN]: true });
					// this.cargoChief.setItem({ [CARGOCHIEF_KEYS.SURVEYS]: payload.survey });
					this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.logged_in, user);

					if (
						!payload.account.termsAgreedAt &&
						user?.role?.toLowerCase().indexOf(ACCOUNT_TYPE.OWNER.toLowerCase()) > -1
					) {
						this.cargoChief.setItem({ [CARGOCHIEF_KEYS.UPDATE_PROFILE]: true });
					}

					localStorage.setItem(
						'loginSetup',
						JSON.stringify({
							user: user,
							account: payload.account,
							accountSettings: payload.accountSettings,
							userSettings: payload.userSettings,
							planProducts: payload.products,
							addOnSubscriptions: payload.addOnSubscriptions,
							activeIntegrations: payload.activeIntegrations,
						})
					);
				})
			),
		{ dispatch: false }
	);
}
